import React from 'react';
import './Skills.css';
import { FaAward } from 'react-icons/fa';

function Skills() {
  const skills = [
    'Linux',
    'Embedded Systems',
    'Windows Server',
    'Hyper-V',
    'Proxmox',
    'KVM',
    'ESXI',
    'Laravel / PHP',
    'Python',
    'Flask',
    'NodeJS',
    'Vue',
    'React',
    'Tailwind',
    'Gumstix',
    'Bluetooth LE/RFID',
    'Bulma',
    'HTML5 / CSS',
    'MySQL / Postgres',
    'Redis / RabbitMQ',
    'Networking',
    'Infrastructure Design',
    'LUA',
    '.NET'
  ];

  const certifications = [
    {
      name: '3CX Basic Certification',
      year: '2026',
      logo: '/img/3cx-basic.png',
      certId: 'Xt5xrxnO9c',
      link: ''
    },
    {
      name: 'Yealink Certified IP Phone Sales Engineer',
      year: '2026',
      logo: '/img/yealink-cipse.png',
      certId: 'YLSIP04026491',
      link: ''
    },
    {
      name: 'Yealink Junior Certified IP Phone Engineer',
      year: '2026',
      logo: '/img/yealink-cippe.png',
      certId: 'YLSIP01026379',
      link: ''
    },
    {
      name: 'App Development with Swift',
      year: '2024',
      logo: '/img/swift.png',
      certId: '',
      link: ''
    },
    {
      name: 'Mikrotik Certified Network Administrator',
      year: '2021',
      logo: 'https://cdn.worldvectorlogo.com/logos/mikrotik.svg',
      certId: '',
      link: ''
    },
    {
      name: 'Red Hat Certified Systems Administrator',
      year: '2013',
      logo: 'https://cdn.worldvectorlogo.com/logos/red-hat-1.svg',
      certId: '',
      link: ''
    },
    {
      name: 'CompTIA A+',
      year: '2012',
      logo: 'https://cdn.worldvectorlogo.com/logos/comptia.svg',
      certId: '',
      link: ''
    },
    {
      name: 'ITIL',
      year: '2012',
      logo: '/img/itil.png',
      certId: '',
      link: ''
    },
    {
      name: 'PRINCE2',
      year: '2012',
      logo: '/img/prince2.png',
      certId: '',
      link: ''
    }
  ];

  return (
    <div className="skills">
      <h2><FaAward className="section-icon" /> Skills</h2>
      <div className="skills-grid">
        {skills.map((skill, index) => (
          <div key={index} className="skill-item">
            <span className="skill-name">{skill}</span>
          </div>
        ))}
      </div>
      <h3 style={{ fontSize: '1.5rem', color: '#ffffff', marginTop: '3rem', marginBottom: '1.5rem' }}>Certifications & Training</h3>
      <div className="certifications-grid">
        {certifications.map((cert, index) => {
          const inner = (
            <div className={`certification-item${cert.link ? ' certification-item--linked' : ''}`}>
              <div className="certification-logo">
                <img src={cert.logo} alt={`${cert.name} logo`} />
              </div>
              <div className="certification-details">
                <div className="certification-name">{cert.name}</div>
                <div className="certification-year">{cert.year}</div>
                {cert.certId && <div className="certification-id">ID: {cert.certId}</div>}
              </div>
            </div>
          );
          return cert.link
            ? <a key={index} href={cert.link} target="_blank" rel="noopener noreferrer" className="certification-link">{inner}</a>
            : <React.Fragment key={index}>{inner}</React.Fragment>;
        })}
      </div>
    </div>
  );
}

export default Skills;
